import React, {useState} from 'react';
import RoundedIcon from "../../../../../../../../../components/Common/RoundedIcon";
import {ReactComponent as CarIco} from "../../../../../../../../../../images/icons/car.svg";
import {useTranslation, withTranslation} from "react-i18next";
import {RootState} from "../../../../../../../../../../reducers";
import {getSession} from "../../../../../../../../../services/Session/reducer";
import {getStoreDefaultConfig} from "../../../../../../../../../services/Store/reducer";
import {connect} from "react-redux";
import {ApiError} from "../../../../../../../../../services/Api/types";
import MultistoreWithHomePageDeliveryForm from "./MultistoreWithHomePageDeliveryForm";
import ErrorFormView from "../../../../../../../../../components/Common/ErrorFormView";

interface OwnProps {
    placeLinkParams?: string[];
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const MultistoreWithHomePageDeliverySection = ({session, defaultConfig, placeLinkParams}: Props) => {
    const {t} = useTranslation();
    const [address, setAddress] = useState(session.address);
    const [forceStreet, setForceStreet] = useState(false);
    const [errors, setErrors] = useState<ApiError[]>([]);

    return (
        <div className="multistore-with-map-home-page-delivery-section">
            <div className="card">
                <div className="d-flex gap-3 mb-4">
                    <RoundedIcon icon={<CarIco/>} className="flex-shrink-0"/>
                    <div>
                        <h5 className="text-dark">
                            {session.full_address ? t("modules.multistore.field.delivery_address.title") : t("common.word.delivery")}
                        </h5>
                        <p className={`mb-0 fw-normal ${session.full_address ? "text-dark" : "text-muted"}`}>
                            {session.full_address || t("modules.multistore.field.provide_your_address.title")}
                        </p>
                        <ErrorFormView errors={errors} field="location"/>
                    </div>
                </div>
                <div>
                    <MultistoreWithHomePageDeliveryForm
                        address={address}
                        forceStreet={forceStreet}
                        setForceStreet={setForceStreet}
                        setAddress={setAddress}
                        errors={errors}
                        setErrors={setErrors}
                        config={defaultConfig}
                        session={session}
                        placeLinkParams={placeLinkParams}
                    />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session),
    defaultConfig: getStoreDefaultConfig(state.config)
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MultistoreWithHomePageDeliverySection));